import { apiQuery } from "utils/queries";
import { api } from "./restUtil";

export type Notification = {
  id: string;
  created_at: string;
  is_read: boolean;
  message: string;
  title: string;
  type: string;
  target_user: {
    id: string;
    first_name: string | null;
    last_name: string | null;
    team: {
      id: string;
      name: string;
    } | null;
  };
};

export const notificationsQuery = apiQuery<{ list: Notification[] }>({
  key: "/notifications",
});

// Team and company managers additionally receive the `tm_` alert toggles and
// their thresholds; every other role gets the four base preferences alone.
export type NotificationSettings = {
  engagement: boolean;
  marketing: boolean;
  reminders: boolean;
  system: boolean;
} & Partial<ManagerNotificationSettings>;

type ManagerNotificationSettings = {
  tm_missed_sessions_email_alert: boolean;
  tm_missed_sessions_inapp_alert: boolean;
  tm_missed_sessions_threshold: number;
  tm_not_booked_sessions_email_alert: boolean;
  tm_not_booked_sessions_inapp_alert: boolean;
  tm_not_booked_sessions_threshold: number;
  tm_inactive_email_alert: boolean;
  tm_inactive_inapp_alert: boolean;
  tm_inactive_threshold: number;
  tm_remaining_sessions_email_alert: boolean;
  tm_remaining_sessions_inapp_alert: boolean;
  tm_remaining_sessions_threshold: number;
  tm_completed_all_sessions_email_alert: boolean;
  tm_completed_all_sessions_inapp_alert: boolean;
  tm_automatically_graduated_email_alert: boolean;
  tm_automatically_graduated_inapp_alert: boolean;
  tm_automatically_deleted_email_alert: boolean;
  tm_automatically_deleted_inapp_alert: boolean;
};

export function fetchNotificationSettings() {
  return api.get<NotificationSettings>("/settings/notifications");
}

export function patchNotificationSettings(args: Partial<NotificationSettings>) {
  return api.patch<Partial<NotificationSettings>>("/settings/notifications", args);
}

type NotificationIdsPayload = {
  notifications: string[];
};

export function deleteNotifications(args: NotificationIdsPayload) {
  return api.delete<NotificationIdsPayload>("/notifications", args);
}
export function isHighSeverityNotification(notification: Notification) {
  return notification.type === "team_member_forfeited";
}
